export default "__VITE_ASSET__CinhkR41__"